import actions from './actions';
import mutations from './mutations';

const state = {
  name: 'Dariuszek',
  activityLogs: [],
  selectedDay: '',
  activityHabits: [],
  habitsWithLogs: [],
  habitsByDay: [],
  logsByDay: [],
  groupsOfHabits: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
